import BannersContainer from './banners_container';

export default BannersContainer;
